import React, { Component } from "react";

export default class TypeCarFilter extends Component {
  render() {
    return (
      <div className="filter-container">
        <div
          className={`filter-item ${this.props.type === "all" ? "active" : ""}`}
          onClick={() => this.props.carTypeSelect("all")}
        >
          Todos
        </div>
        <div
          className={`filter-item ${this.props.type === 6 ? "active" : ""}`}
          onClick={() => this.props.carTypeSelect(6)}
        >
          Híbrido
        </div>

        <div
          className={`filter-item ${this.props.type === 1 ? "active" : ""}`}
          onClick={() => this.props.carTypeSelect(1)}
        >
          SUV y 4x4
        </div>
        <div
          className={`filter-item ${this.props.type === 2 ? "active" : ""}`}
          onClick={() => this.props.carTypeSelect(2)}
        >
          Familiar
        </div>

        <div
          className={`filter-item ${this.props.type === 3 ? "active" : ""}`}
          onClick={() => this.props.carTypeSelect(3)}
        >
          Urbano
        </div>

        <div
          className={`filter-item ${this.props.type === 4 ? "active" : ""}`}
          onClick={() => this.props.carTypeSelect(4)}
        >
          Comercial
        </div>
        <div
          className={`filter-item ${this.props.type === 5 ? "active" : ""}`}
          onClick={() => this.props.carTypeSelect(5)}
        >
          Deportivo
        </div>
      </div>
    );
  }
}
